/* CLV · Variant pills dinámicos
   Re-renderiza los pills de Color/Tamaño al cambiar Tipo, sin recargar.
   Lee las variantes válidas desde #test-json (ya filtradas por sku/stock/FAKE).
   Deja que <variant-selects> (Dawn / global.js) resuelva precio, imagen y carrito
   cuando hay una combinación completa válida.
*/
(function () {
  function init() {
    var jsonEl = document.getElementById('test-json');
    var variantSelects = document.querySelector('variant-selects');
    if (!jsonEl || !variantSelects) return;

    var variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent.trim());
    } catch (e) {
      console.error('CLV variant-pills: no se pudo parsear #test-json', e);
      return;
    }
    if (!Array.isArray(variants) || variants.length === 0) return;

    function inputs(pos) {
      return Array.prototype.slice.call(
        variantSelects.querySelectorAll('input[data-opt-pos="' + pos + '"]')
      );
    }

    function checkedValue(pos) {
      var el = variantSelects.querySelector('input[data-opt-pos="' + pos + '":checked');
      return el ? el.value : null;
    }

    function setVisible(input, visible) {
      var label = variantSelects.querySelector('label[for="' + input.id + '"]');
      input.disabled = !visible;
      input.style.display = visible ? '' : 'none';
      if (label) label.style.display = visible ? '' : 'none';
      if (!visible && input.checked) input.checked = false;
    }

    // Recalcula visibilidad de Color (pos 2) y Tamaño (pos 3) según selección actual.
    function refresh() {
      var tipo = checkedValue(1);

      // Colores válidos para el Tipo seleccionado
      inputs(2).forEach(function (input) {
        var ok = !!tipo && variants.some(function (v) {
          return v.option1 === tipo && v.option2 === input.value;
        });
        setVisible(input, ok);
      });

      var color = checkedValue(2);

      // Tamaños válidos para Tipo + Color seleccionados
      inputs(3).forEach(function (input) {
        var ok = !!tipo && !!color && variants.some(function (v) {
          return v.option1 === tipo && v.option2 === color && v.option3 === input.value;
        });
        setVisible(input, ok);
      });
    }

    variantSelects.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.getAttribute || input.getAttribute('data-opt-pos') == null) return;
      var pos = input.getAttribute('data-opt-pos');

      if (pos === '1') {
        // Cambió el Tipo: limpiar Color y Tamaño, el usuario elige de las nuevas opciones
        inputs(2).forEach(function (i) { i.checked = false; });
        inputs(3).forEach(function (i) { i.checked = false; });
      } else if (pos === '2') {
        // Cambió el Color: limpiar Tamaño
        inputs(3).forEach(function (i) { i.checked = false; });
      }
      refresh();
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();